import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Catcher } from '../';
import { IComponentName } from '../../interfaces';
import { usePagesStoreDefaultComponent, usePagesStoreListName, usePreviousRoute, useRouterStore } from '../../hooks';
import { isAvailablePage } from '../../middleware';
import { tB } from '../../translate';
import Styles from '../styles/m_itemCardStyles.less';

type IBackButton = {
    dataTest?: string;
    isDisable?: boolean;
    runOnBack?: () => void;
};

export const BackButton: React.FC<IBackButton> = ({ dataTest, isDisable, runOnBack }: IBackButton) => {
    const routerStore = useRouterStore();
    const prev = usePreviousRoute();
    const isAvailablePrev = !!prev && isAvailablePage(prev.name as IComponentName);
    const defaultListName = usePagesStoreListName();
    const isRightDefaultList = !!defaultListName && isAvailablePage(defaultListName);
    const defaultComponent = usePagesStoreDefaultComponent();

    const goBack = (): void => {
        runOnBack && runOnBack();
        if (isAvailablePrev) {
            routerStore.goBack();
        } else if (isRightDefaultList && defaultListName) {
            routerStore.goTo(defaultListName);
        } else {
            routerStore.goTo(defaultComponent.routeName);
        }
    };

    return (
        <Catcher>
            <Button
                className={Styles.mainButton}
                data-test={dataTest}
                disabled={isDisable}
                icon={<ArrowLeftOutlined />}
                onClick={goBack}
                type="primary"
            >
                {tB('Back')}
            </Button>
        </Catcher>
    );
};
